import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';

export class ErrorReturn extends Error {
  error: string;
  static appInsights: ApplicationInsights;

  constructor(newError: string) {
    super(newError);
    ErrorReturn.trackError(this);
    this.error = newError;
  }

  static init_AppInsightsLogging = (applicationInsights: ApplicationInsights) => {
    this.appInsights = applicationInsights;
    this.appInsights.loadAppInsights();
  };

  static trackError = (newError: Error) => {
    if (ErrorReturn.appInsights !== undefined) {
      var telemetryInitializer = (envelope: ITelemetryItem) => {};
      ErrorReturn.appInsights.addTelemetryInitializer(telemetryInitializer);
      ErrorReturn.appInsights.trackException({ exception: newError });

      ErrorReturn.appInsights.addTelemetryInitializer(() => false);
    }
  };
}

export class ErrorXMLParsing extends ErrorReturn {
  xmlTrace: string;

  constructor(newError: string, xmlTrace: string) {
    super(newError);
    ErrorXMLParsing.trackXMLError(this);
    this.xmlTrace = xmlTrace;
  }

  static nextXMLTrace = (currentXMLString: string, nextElement: string, elementIdentifier?: string) => {
    if (elementIdentifier === undefined) return `${currentXMLString}>${nextElement}`;
    return `${currentXMLString}>${nextElement}: ${elementIdentifier}`;
  };

  static trackXMLError = (newError: ErrorXMLParsing) => {
    if (ErrorReturn.appInsights !== undefined) {
      var telemetryInitializer = (envelope: ITelemetryItem) => {};
      ErrorReturn.appInsights.addTelemetryInitializer(telemetryInitializer);
      ErrorReturn.appInsights.trackException({ exception: newError, properties: { xmlTrace: newError.xmlTrace } });

      ErrorReturn.appInsights.addTelemetryInitializer(() => false);
    }
  };
}
